import { useQueryClient } from "@tanstack/react-query";

export default function useInvalidateShopSuspense() {
  const queryClient = useQueryClient();
  return (shopId: string) => {
    queryClient.invalidateQueries({
      queryKey: ["get", "/shops/{shopId}", { params: { path: { shopId } } }],
    });
  };
}
